// import React, { useState } from "react";
// import { MdOutlineMenuBook } from "react-icons/md";
// import AdminProfileDropDown from "../../Components/Admin/AdminProfileDropDown";
// import { IoIosArrowDropleft } from "react-icons/io";
// // import FlyingBirds from "../../Components/Common/FlyingBirds";

// const Navbar = ({ toggleSidebar, isSidebarOpen }) => {
//   const [showBirds, setShowBirds] = useState(false);

//   const handleBirdClick = () => {
//     setShowBirds(true);
//     setTimeout(() => setShowBirds(false), 6000);
//   };

//   const storedData = JSON.parse(localStorage.getItem("Nexgen-Admin-Data"));
//   const id = storedData?._id;
//   const fullName = storedData?.name;
//   const firstName = fullName.split(" ")[0];
//   const userType = storedData?.userType;

//   return (
//     <>
//       <div
//         id="nav"
//         className="w-full h-16 bg-white flex flex-row items-center text-[#49608c] shadow-md rounded-xl z-50 sticky top-4"
//       >
//         <div className="ml-5 cursor-pointer">
//           {/* <span onClick={toggleSidebar} className="text-[2.4rem]">
//             🧑‍🎓
//             <IoIosArrowDropleft />
//           </span> */}
//           <span
//             onClick={toggleSidebar}
//             className="text-[2.4rem] cursor-pointer"
//           >
//             <IoIosArrowDropleft
//               className={`transition-transform duration-300 ${
//                 isSidebarOpen ? "rotate-0" : "rotate-180"
//               }`}
//             />
//           </span>
//         </div>

//         <div className="ml-auto flex flex-row items-center ">
//           <div className="flex flex-col items-start">
//             <div className="flex items-center gap-0.5">
//               <h1 className="text-xl font-bold">Hii, {firstName}!</h1>
//               <span className="text-xl">👋</span>
//             </div>

//             <p className="text-sm capitalize font-bold">{userType}</p>
//           </div>

//           <AdminProfileDropDown />
//         </div>
//       </div>
//     </>
//   );
// };

// export default Navbar;

import { useState, useEffect } from "react";
import { IoIosArrowDropleft } from "react-icons/io";
import { RiTimeLine, RiShieldUserLine } from "react-icons/ri";
import AdminProfileDropDown from "../../Components/Admin/AdminProfileDropDown";

const Navbar = ({ toggleSidebar, isSidebarOpen }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const storedData = JSON.parse(localStorage.getItem("Nexgen-Admin-Data"));
  const fullName = storedData?.name || "User";
  const firstName = fullName.split(" ")[0];
  const userType = storedData?.userType || "user";

  const timeStr = currentTime.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  const dateStr = currentTime.toLocaleDateString("en-IN", {
    weekday: "short",
    day: "2-digit",
    month: "short",
  });

  const greet = () => {
    const h = currentTime.getHours();
    if (h < 12) return "Good Morning";
    if (h < 17) return "Good Afternoon";
    return "Good Evening";
  };
  const greetEmoji = () => {
    const h = currentTime.getHours();
    if (h < 12) return "☀️";
    if (h < 17) return "⚡";
    return "🌙";
  };

  return (
    <div
      className="w-full h-16 flex items-center justify-between px-4 sticky top-3 rounded-2xl z-50"
      style={{
        background:
          "linear-gradient(135deg,#080f1e 0%,#0d1b35 60%,#091a2e 100%)",
        border: "1px solid rgba(56,224,200,0.12)",
        boxShadow:
          "0 4px 32px rgba(0,0,0,0.4), 0 1px 0 rgba(56,224,200,0.08) inset",
      }}
    >
      {/* ── Left: toggle + greeting ──────────────────────────────────────────── */}
      <div className="flex items-center gap-3">
        {/* Sidebar toggle */}
        <button
          onClick={toggleSidebar}
          className="w-9 h-9 flex items-center justify-center rounded-xl transition-all duration-200"
          style={{
            background: "rgba(56,224,200,0.08)",
            border: "1px solid rgba(56,224,200,0.18)",
            color: "#38e0c8",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "rgba(56,224,200,0.16)";
            e.currentTarget.style.borderColor = "rgba(56,224,200,0.38)";
            e.currentTarget.style.boxShadow = "0 0 14px rgba(56,224,200,0.22)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "rgba(56,224,200,0.08)";
            e.currentTarget.style.borderColor = "rgba(56,224,200,0.18)";
            e.currentTarget.style.boxShadow = "none";
          }}
        >
          <IoIosArrowDropleft
            size={20}
            style={{
              transition: "transform 0.3s ease",
              transform: isSidebarOpen ? "rotate(0deg)" : "rotate(180deg)",
            }}
          />
        </button>

        {/* Divider */}
        <div
          className="h-6 w-px"
          style={{ background: "rgba(56,224,200,0.12)" }}
        />

        {/* Greeting */}
        <div className="hidden sm:flex flex-col">
          <span
            className="text-[10px] font-semibold uppercase tracking-[0.15em]"
            style={{ color: "rgba(56,224,200,0.65)" }}
          >
            {greet()} {greetEmoji()}
          </span>
          <span
            className="text-sm font-bold leading-tight"
            style={{ color: "#ffffff" }}
          >
            {firstName}
          </span>
        </div>
      </div>

      {/* ── Center: live clock ───────────────────────────────────────────────── */}
      <div
        className="hidden md:flex items-center gap-2 px-4 py-2 rounded-xl"
        style={{
          background: "rgba(255,255,255,0.03)",
          border: "1px solid rgba(255,255,255,0.07)",
        }}
      >
        <RiTimeLine size={13} style={{ color: "rgba(250,189,0,0.75)" }} />
        <span
          className="text-xs font-bold font-mono tracking-wider"
          style={{ color: "rgba(250,189,0,0.9)" }}
        >
          {timeStr}
        </span>
        <div
          className="w-px h-3"
          style={{ background: "rgba(255,255,255,0.12)" }}
        />
        <span
          className="text-[10px]"
          style={{ color: "rgba(255,255,255,0.28)" }}
        >
          {dateStr}
        </span>
      </div>

      {/* ── Right: role badge + profile ──────────────────────────────────────── */}
      <div className="flex items-center gap-3">
        {/* Role badge */}
        <div
          className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-lg"
          style={{
            background: "rgba(250,189,0,0.08)",
            border: "1px solid rgba(250,189,0,0.2)",
          }}
        >
          <RiShieldUserLine size={12} style={{ color: "#fabd00" }} />
          <span
            className="text-[10px] font-bold uppercase tracking-widest"
            style={{ color: "#fabd00" }}
          >
            {userType}
          </span>
        </div>

        {/* Divider */}
        <div
          className="h-6 w-px"
          style={{ background: "rgba(56,224,200,0.12)" }}
        />

        {/* Profile dropdown */}
        <AdminProfileDropDown />
      </div>
    </div>
  );
};

export default Navbar;
